import { Box, Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import { RxCross2 } from 'react-icons/rx';
import { MdOutlineHourglassTop } from 'react-icons/md';
import { A2pBrand } from '@/apis/business/setting/phoneNumbers/types';

type Props = {
  open: boolean;
  brand: A2pBrand | null;
  onClose: () => void;
};

const formatDate = (value?: string) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-GB');
};

const labelSx = { fontSize: 11, color: 'text.secondary', letterSpacing: '0.04em', mb: 0.5 } as const;

export default function BrandVerificationModal({ open, brand, onClose }: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: '8px', width: 400, maxWidth: 'calc(100% - 32px)', m: 2 } }}
    >
      <IconButton
        onClick={onClose}
        size='small'
        sx={{ position: 'absolute', right: 14, top: 14, color: 'text.primary' }}
        aria-label='Close'
      >
        <RxCross2 size={18} />
      </IconButton>
      <DialogContent sx={{ textAlign: 'center', px: 2, pt: 3, pb: 3 }}>
        <Box
          width={56}
          height={56}
          borderRadius='50%'
          bgcolor='#FEF6E4'
          display='flex'
          alignItems='center'
          justifyContent='center'
          mx='auto'
          mb={2}
        >
          <MdOutlineHourglassTop size={26} color='#D97706' />
        </Box>
        <Typography fontSize={18} fontWeight={600} color='text.primary' mb={1}>
          Your brand is being verified
        </Typography>
        <Typography fontSize={12} color='text.secondary' mb={2.5} lineHeight={1.6}>
          Bandwidth is reviewing your brand details. This usually takes 1 to 3 business days. We&apos;ll email you the
          moment a decision is in — no action needed from you right now.
        </Typography>

        <Box
          bgcolor='#F9FAFB'
          border='1px solid #F0F1F3'
          borderRadius='8px'
          px={1.5}
          py={1.5}
          display='grid'
          gridTemplateColumns='1.1fr 1fr 0.8fr'
          gap={1.5}
          textAlign='left'
        >
          <Box>
            <Typography sx={labelSx}>BRAND NAME</Typography>
            <Typography fontSize={13} color='text.primary' noWrap>
              {brand?.display_name || '—'}
            </Typography>
          </Box>
          <Box>
            <Typography sx={labelSx}>SUBMITTED ON</Typography>
            <Typography fontSize={13} color='text.primary'>
              {formatDate(brand?.created_at)}
            </Typography>
          </Box>
          <Box>
            <Typography sx={labelSx}>STATUS</Typography>
            <Typography fontSize={13} fontWeight={600} color='#D97706'>
              IN REVIEW
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
